import { isProd } from "../util/env";

export default () => isProd;
